import axios from "axios"

const API_URL = "https://api.serviceapplications.net/"
//const API_URL = "https://demo.serviceapplications.net/"

class AuthService {    

    ApiUrl() {
        return API_URL
    }

    _simple_get(end_point) {
        var config = { 
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
                'Accept': 'application/json',
            },
        }
        return axios.get(end_point, config).then(response => {
                //console.log(response.data)
                return response.data
            }).catch(error => {
                //console.log("response KO !!!")
                throw error
            })
    }
    getProgramList() {
        // https://www.serviceapplications.net/ProgramList.aspx
        // NUOVO !!! -----> https://api.serviceapplications.net/_home/programsList
        return this._simple_get("https://api.serviceapplications.net/_home/programsList")
    }
    getLang() {
        // https://www.serviceapplications.net/_car/user/api/Release/lang?download=bGFuZ19vbWVnYXNfbWF4
        // NUOVO !!! ----> https://api.serviceapplications.net/Release/lang?n=bGFuZ19vbWVnYXNfbWF4&a=print
        return this._simple_get("https://api.serviceapplications.net/Release/lang?n=bGFuZ19vbWVnYXNfbWF4&a=print")
    }    



    _post(end_point, data, with_jwt = true) {
        var jwt
        var config
        if (with_jwt) {
            jwt = localStorage.getItem('jwt')
            if (!jwt) {
                return new Promise((resolve, reject) => {
                    reject({
                        message: 'token not found'
                    })
                })
            }
            config = {
                headers: {
                    'Authorization': 'Bearer ' + jwt,
                    'Content-Type': 'application/json;charset=utf-8',
                    'Accept': 'application/json',
                },
            }
        } else {
            config = {
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                    'Accept': 'application/json',
                },
            }
        }
        return axios.post(API_URL + end_point, data, config).then(response => {
                //console.log("response ok")
                //console.log(response)
                if (!with_jwt) {
                    if (response.data.is_valid && response.data.jwt) {
                        localStorage.setItem("jwt", response.data.jwt)
                    }
                }
                return response.data
            }).catch(error => {
                //console.log("response KO !!!")
                throw error
            })
    }

    ServiceUserLogin(username, password) {
        return this._post("ServiceUser/login", {
            username: username, 
            password: password
        }, false)        
    }    
    ResetPassword(email, captcha) {
        return this._post("ServiceUser/resetPassword", {
            email: email,
            captcha: captcha
        }, false)
    }    
    ChangePassword(reset_code, password, confirm_password) {
        return this._post("ServiceUser/changePassword", {
            resetCode: reset_code,
            password: password,
            confirmPassword: confirm_password,
        }, false)
    }    
    logout() {
        localStorage.removeItem("jwt")
    }    
    ValidateServiceUserToken() {
        return this._post("ServiceUser/validateToken", {})        
    }
    
    ecuConvertCalib(calib) {
        return this._post("Ecu/convertCalib", {
            calib: calib,
        })
    }

    getDiagBuffer(id) {
        return this._post("Ecu/getDiagBuffer", {
            id: parseInt(id),
        })
    }
    getEcuCalib(calib_id, ccal) {
        return this._post("Ecu/getCalib", {
            id: parseInt(calib_id),
            ccal: ccal,
        })
    }
    getEcuHistory(id) {
        return this._post("Ecu/history", {
            id: parseInt(id),
        })
    }
    getEcuProdDate(id) {
        return this._post("Ecu/getProdDate", {
            id: parseInt(id),
        })
    }
    getEcuInfo(id) {
        return this._post("Ecu/info", {
            id: parseInt(id),
        })
    }
    getEcuList(skip, take, sorting, filters) {
        const config = {
            skip: skip, 
            take: take, 
            sort: {
                selector: sorting.columnName,
                desc: sorting.direction === 'desc',
            }, 
            filters: filters.map(item => {
                return {
                    selector: item.columnName,
                    op: item.operation,
                    value: item.value,
                }
            }),
        }
        return this._post("Ecu/list", config)
    }
    getEcuCount(filters) {
        const config = {
            filters: filters.map(item => {
                return {
                    selector: item.columnName,
                    op: item.operation,
                    value: item.value,
                }
            }),
        }
        return this._post("Ecu/count", config)
    }
    getEcuSign(data) {
        return this._post("Ecu/sign", data)
    }
    
    
    getLicense(user_code) {
        const config = {
            user_code: user_code, 
        }
        return this._post("Computer/getLicense", config)
    }
    viewLicense(user_code) {
        const config = {
            user_code: user_code, 
        }
        return this._post("Computer/viewLicense", config)
    }

    getComputerList(skip, take, sorting, filters) {
        const config = {
            skip: skip, 
            take: take, 
            sort: {
                selector: sorting.columnName,
                desc: sorting.direction === 'desc',
            }, 
            filters: filters.map(item => {
                return {
                    selector: item.columnName,
                    op: item.operation,
                    value: item.value,
                }
            }),
        }
        return this._post("Computer/list", config)
    }
    getComputerCount(filters) {
        const config = {
            filters: filters.map(item => {
                return {
                    selector: item.columnName,
                    op: item.operation,
                    value: item.value,
                }
            }),
        }
        return this._post("Computer/count", config)
    }


    getLogUpdateSince(date, limit) {
        return this._post("LogUpdate/since", {
            date: date.format("YYYY-MM-DD HH:mm:ss"),
            limit: limit
        })        
    }


    getServiceUserDetails(id) {
        return this._post("ServiceUser/details", {
            id: parseInt(id),
        })
    }
    setServiceUserDetails(data) {
        return this._post("ServiceUser/update", data)
    }

    async searchServiceUsers(value) {
        return this._post("ServiceUser/search", { value })
    }
    
    getServiceUserList(skip, take, sorting, filters) {
        const config = {
            skip: skip, 
            take: take, 
            sort: {
                selector: sorting.columnName,
                desc: sorting.direction === 'desc',
            }, 
            filters: filters.map(item => {
                return {
                    selector: item.columnName,
                    op: item.operation,
                    value: item.value,
                }
            }),
        }
        //console.log("ServiceUserList")
        //console.log(JSON.stringify(config))
        //console.log(JSON.stringify(filters))
        return this._post("ServiceUser/list", config)
    }
    getServiceUserCount(filters) {
        const config = {
            filters: filters.map(item => {
                return {
                    selector: item.columnName,
                    op: item.operation,
                    value: item.value,
                }
            }),
        }
        return this._post("ServiceUser/count", config)
    }


    
    getServiceUnlockCodeList(skip, take, sorting, filters, unlocker_id) {
        const config = {
            skip: skip, 
            take: take, 
            sort: {
                selector: sorting.columnName,
                desc: sorting.direction === 'desc',
            }, 
            filters: filters.map(item => {
                return {
                    selector: item.columnName,
                    op: item.operation,
                    value: item.value,
                }
            }),
            unlocker_id: unlocker_id,
        }
        return this._post("ServiceUnlockCode/list", config)
    }
    getServiceUnlockCodeCount(filters, unlocker_id) {
        const config = {
            filters: filters.map(item => {
                return {
                    selector: item.columnName,
                    op: item.operation,
                    value: item.value,
                }
            }),
            unlocker_id: unlocker_id,
        }
        return this._post("ServiceUnlockCode/count", config)
    }


    copySoftwareToolToRelease(hash) {
        const config = {
            hash: hash,
        }
        return this._post("SoftwareTool/copyToRelease", config)
    }
    deleteSoftwareToolFromRelease(hash) {
        const config = {
            hash: hash,
        }
        return this._post("SoftwareTool/deleteFromRelease", config)
    }
    getSoftwareToolList(skip, take, sorting, filters, mode) {
        const config = {
            skip: skip, 
            take: take, 
            sort: {
                selector: sorting.columnName,
                desc: sorting.direction === 'desc',
            }, 
            filters: filters.map(item => {
                return {
                    selector: item.columnName,
                    op: item.operation,
                    value: item.value,
                }
            }),            
            last: (mode === "last"),
        }
        return this._post("SoftwareTool/list", config)
    }
    getSoftwareToolCount(filters, mode) {
        const config = {
            filters: filters.map(item => {
                return {
                    selector: item.columnName,
                    op: item.operation,
                    value: item.value,
                }
            }),
            last: (mode === "last"),
        }
        return this._post("SoftwareTool/count", config)
    }

    getSoftwareFwList(skip, take, sorting, filters, mode) {
        const config = {
            skip: skip, 
            take: take, 
            sort: {
                selector: sorting.columnName,
                desc: sorting.direction === 'desc',
            }, 
            filters: filters.map(item => {
                return {
                    selector: item.columnName,
                    op: item.operation,
                    value: item.value,
                }
            }),            
            last: (mode === "last"),
        }
        return this._post("SoftwareFw/list", config)
    }
    getSoftwareFwCount(filters, mode) {
        const config = {
            filters: filters.map(item => {
                return {
                    selector: item.columnName,
                    op: item.operation,
                    value: item.value,
                }
            }),
            last: (mode === "last"),
        }
        return this._post("SoftwareFw/count", config)
    }



    setComputerReseller(computer_id, reseller_id) {
        const config = {
            computer_id: computer_id,
            reseller_id: reseller_id,
        }
        return this._post("Computer/setReseller", config, true /* with_jwt */)
    }
    getResellerList(bearer = undefined) {
        if (bearer) {
            const config = {
                bearer: bearer, 
            }
            return this._post("ServiceUser/resellers", config, false /* with_jwt */)
        } else {
            return this._post("ServiceUser/resellers", {}, true /* with_jwt */)
        }
    }
    getComputerInfo(bearer, id = "0") {
        const config = {
            bearer: bearer, 
            id: parseInt(id),
        }
        return this._post("Computer/info", config, false /* with_jwt */)
    }
    getComputerVerify(bearer, id, num) {
        const config = {
            bearer: bearer, 
            id: parseInt(id),
            num: parseInt(num),
        }
        return this._post("Computer/verify", config, false /* with_jwt */)
    }
    addServiceUser(user) {
        const config = {
            user: user,
        }
        return this._post("ServiceUser/add", config, true /* with_jwt */)
    }



    addComputerToNew(bearer, user, reseller_id) {
        const config = {
            bearer: bearer, 
            user: user,
            reseller_id: reseller_id,
        }
        return this._post("Computer/addToNew", config, false /* with_jwt */)
    }
    addComputerToExisting(bearer, user, reseller_id) {
        const config = {
            bearer: bearer, 
            user: {
                username: user.username,
                password: user.password,
            },
            reseller_id: reseller_id,
        }
        return this._post("Computer/addToExisting", config, false /* with_jwt */)
    }
    addComputerToUser(bearer, user, reseller_id) {
        const config = {
            bearer: bearer, 
            user: user,
            reseller_id: reseller_id,
        }
        return this._post("Computer/addToUser", config, true /* with_jwt */)
    }
    addComputer(user_code, username, reseller_id) {
        const config = {
            user_code: user_code, 
            username: username,
            reseller_id: reseller_id,            
        }
        return this._post("Computer/add", config, true /* with_jwt */)
    }



    deleteComputer(data) {
        return this._post("Computer/delete", data, true /* with_jwt */)
    }
    forceServiceUserActivation(user_id) {
        const config = {
            user_id: user_id,
        }
        return this._post("ServiceUser/forceActivation", config, true /* with_jwt */)
    }

    updateComputerAutoLicense(data) {
        return this._post("Computer/updateAutoLicense", data, true /* with_jwt */)
    }

    buildLicense(data) {
        return this._post("Computer/buildLicense", data, true /* with_jwt */)
    }
    getUnlockCode(data) {
        return this._post("Computer/buildUnlockCode", data, true /* with_jwt */)
    }

    // FW Reseller CRUD
    getFwResellerList(skip, take, sorting, filters) {
        const config = {
            skip: skip,
            take: take,
            sort: {
                selector: sorting.columnName,
                desc: sorting.direction === 'desc',
            },
            filters: filters.map(item => {
                return {
                    selector: item.columnName,
                    op: item.operation,
                    value: item.value,
                }
            }),
        }
        return this._post("Ecu/fwReseller/list", config)
    }
    getFwResellerCount(filters) {
        const config = {
            filters: filters.map(item => {
                return {
                    selector: item.columnName,
                    op: item.operation,
                    value: item.value,
                }
            }),
        }
        return this._post("Ecu/fwReseller/count", config)
    }
    getFwResellerGet(id) {
        return this._post("Ecu/fwReseller/get", { id: parseInt(id) })
    }
    createFwReseller(data) {
        return this._post("Ecu/fwReseller/create", data)
    }
    updateFwReseller(data) {
        return this._post("Ecu/fwReseller/update", data)
    }
    deleteFwReseller(id) {
        return this._post("Ecu/fwReseller/delete", { id: parseInt(id) })
    }

}

export default new AuthService()
